import { Component, OnChanges, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'psr-review-popup',
	templateUrl: './psr-review-popup.html',
	styleUrls: ['./psr-review-popup.less'],
})
export class PSRReviewPopup implements OnInit {
	@Input('weekendingDate') weekendingDate: any = {};
	@Input('productionStatus') productionStatus: any = {};
	@Input('productionStudio') productionStudio: any = {};
	@Input('selectedTitles') selectedTitles: any = {};
    @Input('psrReviewPopupVisible') psrReviewPopupVisible: any = false;
    @Input('fileName') fileName!: string;
    @Input('showSendReportButton') showSendReportButton!: boolean;
	@Output() setSendReportStatus = new EventEmitter<number>();
	@Output() hidePopup = new EventEmitter();
	constructor(){}
	ngOnInit(): void {}
	sendReport = (e: any) => {
		this.setSendReportStatus.emit(2);
		this.isToastVisible = true;
	}
	closePopup = (e: any) => {
		this.hidePopup.emit();
	}
	isToastVisible: boolean = false;
	onHidden = (e: any) => {
		this.isToastVisible = false;
	}
}
